import React from "react";
import { Link } from "react-router-dom";
import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import { usePackages } from "../hooks/usePackages";

export default function TopDestinationOne(){
    const { packages, loading, error } = usePackages();
    const items = packages.slice(0, 10);

    const settings = {
        container: '.tiny-five-item',
        controls: true,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        controlsText: ['<i class="mdi mdi-chevron-left "></i>', '<i class="mdi mdi-chevron-right"></i>'],
        nav: false,
        speed: 400,
        gutter: 0,
        responsive: {
            1025: { items: 5 },
            992: { items: 4 },
            767: { items: 3 },
            425: { items: 1 },
        },
      };

    return(
        <div className="container relative">
            <div className="grid grid-cols-1 pb-8 text-center">
                <h3 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Principales destinos</h3>
                <p className="text-slate-400 max-w-xl mx-auto">¿Planeando un viaje? ¡Organizamos tu viaje con los mejores lugares y al mejor precio!</p>
            </div>

            <div className="grid grid-cols-1 relative mt-6">
                {loading && <p className="text-center text-slate-400">Cargando destinos...</p>}
                {error && <p className="text-center text-red-500">{error}</p>}
                {!loading && !error && (
                    <div className="tiny-five-item">
                        <TinySlider settings={settings}>
                            {items.map((item,index)=>{
                                const cover = item.images?.[0]?.url || item.hero_image_url || '';
                                const place = item.destination?.name || item.title;
                                return(
                                    <div className="tiny-slide" key={index}>
                                        <Link to={`/tour-detail-one/${item.id}`} className="group relative overflow-hidden rounded-md shadow dark:shadow-gray-800 m-2 block">
                                            {cover ? (
                                                <img src={cover} className="w-full h-72 object-cover scale-125 group-hover:scale-100 duration-500" alt={place}/>
                                            ) : (
                                                <div className="w-full h-72 bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-500">Sin imagen</div>
                                            )}
                                            <div className="absolute inset-0 bg-gradient-to-b to-slate-900 from-transparent opacity-0 group-hover:opacity-100 duration-500"></div>
                                            <div className="absolute p-4 bottom-0 start-0">
                                                <span className="text-lg font-medium text-white hover:text-red-300 duration-500 ease-in-out">{place}</span>
                                                <p className="text-white/70 group-hover:text-white text-sm duration-500" style={{display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{item.summary || 'Ver detalle del tour'}</p>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })}
                        </TinySlider>
                    </div>
                )}
            </div>
        </div>
    )
}
